import { AfterViewInit, Component, ElementRef, inject, Input, OnDestroy, ViewChild } from "@angular/core";
import { Router } from "@angular/router";
import { AuctionStatus, ClickarPath } from "@shared/clickar-constants";
import { AuctionDTO } from "@shared/model/auction.model";
import { VehicleDTO } from "@shared/model/vehicle.model";
import { ClickarUtilsService } from "@shared/services/utils/clickar-utils.service";
@Component({
	selector: "app-auction-card",
	templateUrl: "./auction-card.component.html",
	styleUrl: "./auction-card.component.scss",
	standalone: false
})
export class AuctionCardComponent implements AfterViewInit, OnDestroy {
	protected AucStatus = AuctionStatus;
	@Input({ required: true }) auction: AuctionDTO | undefined;
	@Input({ required: true }) randomVehicles!: {
		[p: string]: VehicleDTO[];
	};
	@Input({ required: true }) showAuctionType!: boolean;
	protected utils = inject(ClickarUtilsService);
	private router = inject(Router);

	@ViewChild('subtitleEl') subtitleEl!: ElementRef;

	isSubtitleTruncated = false;
	private resizeObserver!: ResizeObserver;

	ngAfterViewInit() {
		this.setupResizeObserver();
		this.checkOverflow();
	}

	setupResizeObserver() {
		this.resizeObserver = new ResizeObserver(() => {
			this.checkOverflow();
		});

		this.resizeObserver.observe(this.subtitleEl.nativeElement);
	}

	checkOverflow() {
		const el = this.subtitleEl.nativeElement as HTMLElement,
			clone = el.cloneNode(true) as HTMLElement;

		Object.assign(clone.style, {
			position: "absolute",
			visibility: "hidden",
			pointerEvents: "none",
			height: "auto",
			maxHeight: "none",
			webkitLineClamp: "unset",
			display: "block",
			overflow: "visible",
			width: `${el.clientWidth}px`
		});

		document.body.appendChild(clone);

		this.isSubtitleTruncated = clone.scrollHeight > el.clientHeight;

		document.body.removeChild(clone);
	}

	getDaysLeft(endDate: Date): number {
		const diff = new Date(endDate).getTime() - Date.now();
		return diff <= 0 ? 0 : Math.ceil(diff / 864e5);
	}

	getHoursLeft(endDate: Date): number {
		const diff = new Date(endDate).getTime() - Date.now();
		return diff <= 0 ? 0 : Math.floor(diff / 36e5);
	}

	getMinutesLeft(endDate: Date): number {
		const diff = new Date(endDate).getTime() - Date.now();
		return diff <= 0 ? 0 : Math.floor((diff % 36e5) / 6e4);
	}

	getAuctionCardStatus(auction: any): string {
		switch (auction.status) {
			// NOT STARTED
			case "CLD":
				return "not-started";
			// break;
			case "RUN":
				return /* now */ Date.now() >= /* end */ new Date(auction.endDate).getTime()
					? // EXTRA TIME
					"extra-time"
					: // ACTIVE RUN
					"run";
		}
		return "not-started";
	}

	goToDetails(idAuction: number) {
		if (idAuction) {
			this.router.navigate(
				[`${ClickarPath.PRIVATE}/${ClickarPath.AUCTION_DETAILS}`],
				{ queryParams: { idAuction } }
			);
		}
	}

	readMore(idTemplate: number) {
		if (idTemplate) {
			this.router.navigate(
				[`${ClickarPath.PRIVATE}/${ClickarPath.PARTNER}`],
				{
					queryParams: { idTemplate }
				}
			);
		}
	}

	ngOnDestroy() {
		if (this.resizeObserver) {
			this.resizeObserver.disconnect();
		}
	}
}
